<bw-action-card-legacy
  (ctaClicked)="routeToCreditSetup()"
  [cardConfig]="creditInitialCard"
></bw-action-card-legacy>
